import { useQuery } from "@tanstack/react-query";
import api, { ApiCatalog } from "@/api";

const useLangstonAttachmentsQuery = (contentId: string) => {
  return useQuery({
    queryKey: [ApiCatalog.contentDocumentAttachments.key, contentId],
    queryFn: () => {
      return api().get(`${ApiCatalog.contentDocumentAttachments.endpoint}`, {
        urlReplacers: [{ contentId }],
      });
    },
  });
};

export default useLangstonAttachmentsQuery;
